import { computed, Injectable } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { select2 } from '@app/srv/store.service'
import { UserSettings } from '../reducers/userSettings.reducer.js'

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
  private currentAnnouncement = toSignal(select2(s => s.announcement))
  private userSettings = toSignal(select2(s => s.userSettings))

  public announcement = computed(() => {
    const currentAnnouncement = this.currentAnnouncement()
    const userSettings = this.userSettings()
    const announcementRead =
      userSettings &&
      !!userSettings[`announcementRead--${currentAnnouncement?.id}` as keyof UserSettings]

    if (announcementRead) return null
    return currentAnnouncement
  })
}
